import { render } from "./SettingList.vue?vue&type=template&id=2aaa2b0d"
import script from "./SettingList.vue?vue&type=script&lang=js"
export * from "./SettingList.vue?vue&type=script&lang=js"

import "./SettingList.vue?vue&type=style&index=0&id=2aaa2b0d&lang=less"

import exportComponent from "D:\\LuisFolder\\project\\evcharge-ev-server-rocketmq\\evcharge-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__